import { createActionGroup, props } from '@ngrx/store';
import { CommandProgress } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';
import { OSUpdateStatus } from './devices-os-update-status.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DevicesOsUpdateStatesResolverActions = createActionGroup({
  source: 'Devices OS Update States Resolver',
  events: {
    'os Update States requested': props<{ categoryId: string }>(),
  },
});

export const DeviceOsUpdateStatesResolverActions = createActionGroup({
  source: 'Device OS Update States Resolver',
  events: {
    'os Update State requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SignalRActions = createActionGroup({
  source: 'SignalR',
  events: {
    'Received os update status command': props<{ commandProgress: CommandProgress }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DevicesApiActions = createActionGroup({
  source: 'Devices OS Update States',
  events: {
    'os Update States loaded': props<{ osUpdateStatuses: OSUpdateStatus[] }>(),
    'os Update States loaded error': props<{ error: ErrorModel }>(),
  },
});

export const DeviceApiActions = createActionGroup({
  source: 'Device OS Update States',
  events: {
    'os Update State loaded': props<{ osUpdateStatus: OSUpdateStatus }>(),
    'os Update State loaded error': props<{ error: ErrorModel }>(),
  },
});
